<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Methods ---

const openFindModal = () => {
    store.dispatch('modals/show', {
        componentName: 'ThemesFindModal',
    });
};
</script>

<template>
    <button class="dropdown-item d-flex align-items-center" type="button" @click="openFindModal">
        <i class="me-2 bi-search"/>
        Find
    </button>
</template>